import { Typography } from '@branch-messenger/willow-ui'
import { use } from 'react'
import { useTheme } from 'styled-components'

import { DialogContext } from '@/context'

import { HandleExistingUserInSameOrgProps } from './useHandleCreateUserConflict.types'

export const useHandleCreateUserConflict = () => {
  const { showAlert } = use(DialogContext)
  const theme = useTheme()

  const handleCreateUserConflict = ({
    error,
  }: HandleExistingUserInSameOrgProps) => {
    const userExistsInOrg = error?.detail?.includes('already exists')
    const userExistsInSameOrgWithSameEmail =
      error?.detail?.includes('User with username')
    const userExistsInSameOrgWithSamePhone = error?.detail?.includes(
      'User with phone number'
    )

    const userExistsInOrgWithSameInfo =
      userExistsInOrg &&
      (userExistsInSameOrgWithSameEmail || userExistsInSameOrgWithSamePhone)

    if (!userExistsInOrgWithSameInfo) {
      return { errorHandled: false }
    }

    const matchTypeDisplay = userExistsInSameOrgWithSamePhone
      ? 'Phone number'
      : 'Email address'
    const matchTypeAlternateDisplay = userExistsInSameOrgWithSamePhone
      ? 'phone number'
      : 'email'

    showAlert({
      title: `${matchTypeDisplay} already in use.`,
      description: (
        <>
          <Typography
            as="span"
            style={{ marginBottom: theme.space[2], display: 'block' }}
          >
            The {matchTypeDisplay.toLowerCase()} you entered is already
            associated with an account.
          </Typography>
          <Typography as="span">
            If you already have an account, please log in. Otherwise, use a
            different {matchTypeAlternateDisplay} or contact support.
          </Typography>
        </>
      ),
      hideCancel: true,
    })

    return { errorHandled: true }
  }

  return handleCreateUserConflict
}
